// import React from 'react'
import './Home.css';
import React from 'react';
import { motion } from 'framer-motion';
import Button from '../../Components/Button/Button';
import ArrowBtn from '../../Components/ArrowBtn/ArrowBtn';
import Highlights from '../Highlights/Highlights';
import SectionIds from '../../Helper/SectionId';
import scrollIntoView from '../../Helper/ScrollIntoView';
import AssetImage from '../../Helper/AssetImage';
import AssetImages from '../../Helper/AssetImages';
import SectionWithAnalytics from '../../Components/sectionWithAnalytics';

export default function Home(props) {
    const textA = "Your partner for ";
    const textB = "Smart Investment";
    return (
        <div className='section-bg'>
            <SectionWithAnalytics ref={props.ref} id={SectionIds.sectionHome} className='section-home'>
                <div className='home-content res-gap-16'>
                    <main className='content-top container-vertical res-gap-32'>
                        <div className='container-vertical res-gap-24'>
                            <h1 className='landing-title fw-extrabold clr-grey-100' >
                                {
                                    textA.split(' ').map((ele, index) =>
                                        <motion.span key={index}
                                            initial={{ opacity: 0 }}
                                            animate={{ opacity: 1 }}
                                            transition={{
                                                duration: 0.5,
                                                delay: index * 0.2
                                            }}>
                                            {ele + ' '}
                                        </motion.span>

                                    )

                                }
                                <br />
                                <mark>
                                    {
                                        textB.split(' ').map((ele, index) =>
                                            <motion.span key={index}
                                                initial={{ opacity: 0 }}
                                                animate={{ opacity: 1 }}
                                                transition={{
                                                    duration: 0.5,
                                                    delay: 0.6 + index * 0.2
                                                }}>
                                                {ele + ' '}
                                            </motion.span>
                                        )
                                    }
                                </mark>
                            </h1>
                            <motion.div

                                className='landing-subtitle container-horizontal gap-100 fs-medium clr-grey-100'
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{
                                    duration: 0.5,
                                    delay: 1
                                }}
                            >
                                Associated with

                                <span>
                                    <AssetImage assetImage={AssetImages.imageGlobeLogo} />
                                </span>
                            </motion.div>
                        </div>

                        <div className='container-horizontal res-gap-32'>
                            <motion.span
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{
                                    duration: 0.5,
                                    delay: 1.2
                                }}>
                                
                                <Button 
                                    name='Explore Services'
                                    onClick={() => scrollIntoView(SectionIds.sectionWGYC)} />
                            </motion.span>
                            <motion.span
                                initial={{ opacity: 0 }}
                                animate={{ opacity: 1 }}
                                transition={{
                                    duration: 0.5,
                                    delay: 1.4
                                }}>

                                <ArrowBtn onClick={() => scrollIntoView(SectionIds.sectionContactMe)} > Enquire </ArrowBtn>

                            </motion.span>
                        </div>
                    </main>

                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{
                            duration: 0.5,
                            delay: 0.6
                        }}
                        className='banner-img-container'

                    >
                        <AssetImage
                            assetImage={AssetImages.imageHomeBanner}
                            style={{
                                visibility: 'hidden'
                            }}
                        />
                        <AssetImage
                            assetImage={AssetImages.imageHomeBanner}
                            className='banner-img'
                        />

                    </motion.div>

                </div>
            </SectionWithAnalytics>

            <Highlights />

        </div>
    )
}
